import React, { Component } from "react";
import { FormGroup, FormControl, ControlLabel, PageHeader } from "react-bootstrap";
import LoaderButton               from "../../components/LoaderButton";
import Amplify, { Auth }          from 'aws-amplify';
import { invokeGetAppMainUserId } from "../../utils/AwsInvoke";
import { Colors }                 from "../../utils/Colors"
import { WhiteLabel }             from "../../utils/WhiteLabelProps";
//import "../css/Login.css";

var white_label = WhiteLabel();

const REACT_APP_COMPANY_LOGO_SQ = sessionStorage.getItem('company_login_logo'); //process.env.REACT_APP_COMPANY_LOGO_SQ
const REACT_APP_S3_BUCKET_URL   = sessionStorage.getItem('s3_bucket_url');
const REACT_APP_S3_BUCKET_NAME  = sessionStorage.getItem('s3_bucket_name');

const REACT_APP_COMPANY_LOGO_URL = "https://" + REACT_APP_S3_BUCKET_URL + "/" + REACT_APP_S3_BUCKET_NAME + "/logos/" + REACT_APP_COMPANY_LOGO_SQ;


export default class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
          isLoading: false,
          template_id:   `${this.props.match.params.template_id}`,
          error: false
        };
    }

    async componentDidMount() {
      try {
          await Auth.currentSession();
          this.userHasAuthenticated(true);
      }
      catch(e) {
        if (e !== 'No current user') {
          console.log("error dude: " + e);
        }
      }

      this.setState({ isAuthenticating: false });
    }

    handleSubmit = async event => {
        event.preventDefault();

        this.setState({
            isLoading: true,
            error: false
        });

        try {

        } catch (e) {
            this.setState({ isLoading: false, error: true });
        }
    }

    render() {

        return (
          <div className="Login">

                <span className="loginLogo">
                    <img src={REACT_APP_COMPANY_LOGO_URL} width="140"/><br/><br/>
                    <span style={{fontSize:34, textAlign:"center"}}>
                        Challenge Board
                    </span>
                    <span>
                        4100 Points
                    </span>
                </span>
                <form onSubmit={this.handleSubmit} style={{position:"relative", top:"-30px"}}>
                </form>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/challenge/Challenge.js